import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { UserType } from '../../../../../interfaces/portal';
import formatFullName from '../../../../../helpers/formatFullName';

const { Cell } = Table;

const NameCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props}>
    {formatFullName([rowData.firstName, rowData.lastName])}
  </Cell>
);
NameCell.propTypes = {
  rowData: UserType,
  dataKey: PropTypes.string.isRequired
};

NameCell.defaultProps = {
  rowData: null
};

export default NameCell;
